import React from "react";
import { lib } from "../../index";
import { SearchList } from "../../config-center-v3";
import HOC from "../../util/HOC";

@HOC.mapAuthButtonsToState({
    pagePath: "/dept-manage",
    buttonCodeArr: ["log"],
})
export default class DeptLog extends SearchList {
    constructor(props) {
        super(props);
        this.state.buttons = [];
    }

    getConfig() {
        return Promise.resolve({
            page: {
                api: "/ucenter-admin/dept/logList",
                bordered: true,
                onlyOneLevel: true,
            },
            searchKeyList: [
                {
                    id: 2,
                    label: "操作人",
                    key: "operatorName",
                    type: "input",
                    extra: "",
                },
                {
                    id: 3,
                    label: "操作时间",
                    type: "date",
                    isRange: true,
                    dateType: "second",
                    start: "operationTimeStart",
                    end: "operationTimeEnd",
                    extra: "",
                },
            ],
            tableFieldList: [
                {
                    id: 2,
                    title: "操作内容",
                    key: "log",
                    width: 300,
                    fixed: "show",
                },
                {
                    id: 3,
                    title: "操作人",
                    key: "operator",
                    width: 120,
                    fixed: "show",
                },
                {
                    id: 4,
                    title: "操作时间",
                    key: "renderOperateTime",
                    width: 180,
                    fixed: "show",
                    type: "function",
                },
            ],
        });
    }

    configLoadDefaultParams() {
        return {
            systemCode: lib.config.systemCode,
            id: lib.getParam("departmentId"),
        };
    }

    reload() {
        this.load(true);
    }

    renderOperationType(row) {
        const typeMap = {
            CREATE: { text: "新增", color: "success" },
            UPDATE: { text: "修改", color: "warning" },
            DELETE: { text: "删除", color: "danger" },
            BIND_USER: { text: "绑定用户", color: "info" },
            UNBIND_USER: { text: "解绑用户", color: "secondary" },
        };

        const type = typeMap[row.operationType] || { text: row.operationType, color: "default" };

        return <span className={`text-${type.color}`}>{type.text}</span>;
    }

    renderOperateTime(row) {
        if (!row.operateTime) {
            return "-";
        }

        // 将时间戳转换为中文时间格式
        const date = new Date(row.operateTime);
        return date.format("yyyy-MM-dd hh:mm:ss");
    }

    renderOperationTopView() {
        return (
            <div>
                <span>部门【{lib.getParam("deptName")}】操作日志</span>
            </div>
        );
    }
}
